module.exports = __webpack_public_path__ + "img/image14.8c8a7d7e.jpg";